import { render } from "./TeamReset.vue?vue&type=template&id=1de6128a&scoped=true"
import script from "./TeamReset.vue?vue&type=script&lang=js"
export * from "./TeamReset.vue?vue&type=script&lang=js"

import "./TeamReset.vue?vue&type=style&index=0&id=1de6128a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1de6128a"

export default script